/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import { GETAUCTIONEERLIVE, UPDATEAUCTIONEERLIVE, GETINVENTORYPROJECTDETAILS } from './mutation-types';

export default {

  [GETAUCTIONEERLIVE](state, payload) {
    state.auctioneerLive = payload;
  },

  [UPDATEAUCTIONEERLIVE](state, payload) {
    if (`${state.auctioneerLive.auction_id}` === `${payload.auction_id}`)
      state.auctioneerLive = payload;
  },
  [GETINVENTORYPROJECTDETAILS](state, payload) {
    state.inventoryDetails = payload;
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/auctioneer/mutations.js